import { render, staticRenderFns } from "./freeAccessoriesOrder.vue?vue&type=template&id=5a4c42c6"
import script from "./freeAccessoriesOrder.vue?vue&type=script&lang=js"
export * from "./freeAccessoriesOrder.vue?vue&type=script&lang=js"
import style0 from "./freeAccessoriesOrder.vue?vue&type=style&index=0&id=5a4c42c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports